import { includes } from "lodash";
import { type FunctionComponent } from "react";
import { FeatureFlagUpsertCommandFeatureEnum } from "@/config/apiClient";
import {
  ReportingMetadata,
  type ReportingMetadataProps,
} from "../components/ReportingMetadata";

export const FLAG_WITH_EXTRA_DATA = [
  FeatureFlagUpsertCommandFeatureEnum.Reporting,
] as const;
export type FlagWithExtraData = (typeof FLAG_WITH_EXTRA_DATA)[number];

// Both components have the same props interface
type MetadataComponentProps = ReportingMetadataProps;

const METADATA_BY_FEATURE: Record<
  FlagWithExtraData,
  FunctionComponent<MetadataComponentProps>
> = {
  [FeatureFlagUpsertCommandFeatureEnum.Reporting]: ReportingMetadata,
};

export const getMetadataByFeature = (
  feature: FeatureFlagUpsertCommandFeatureEnum,
  indexOnForm: number
) => {
  if (!includes(FLAG_WITH_EXTRA_DATA, feature)) {
    return undefined;
  }

  const MetadataComponent = METADATA_BY_FEATURE[feature as FlagWithExtraData];

  return <MetadataComponent indexOnForm={indexOnForm} />;
};
